import { IOrder } from "../stores/order";
import { OrderStatus, PaymentMethod, PaymentStatus } from "../stores/index.d";

// Kitchen identity must not include audit, payment or print-status timestamps.
export const kitchenVersion = (order: IOrder): string => {
  const content = JSON.stringify([
    order.orderId, order.tableNumber, order.orderNote || "",
    [...order.orderItems].sort((a, b) => a.orderItemId - b.orderItemId).map(item => [
      item.orderItemId, item.productId, item.quantity, item.choosenAddOns || "",
      item.price, item.addOnsPrice, item.totalAmount,
    ]),
  ]);
  let a = 2166136261;
  let b = 5381;
  for (let i = 0; i < content.length; i++) {
    a = Math.imul(a ^ content.charCodeAt(i), 16777619);
    b = Math.imul(b, 33) ^ content.charCodeAt(i);
  }
  return `${order.orderId}:${(a >>> 0).toString(16)}${(b >>> 0).toString(16)}`;
};

const paymentReady = (order: IOrder) =>
  order.paymentMethod !== PaymentMethod.Card || order.paymentStatus === PaymentStatus.Paid;

/** Opening or refreshing the page is never permission to print a historical backlog. */
export class KitchenPrintPolicy {
  private initialized = false;
  private observed = new Map<number, { version: string; ready: boolean }>();
  private pending = new Set<string>();

  initialize(orders: IOrder[]) {
    if (this.initialized) return;
    orders.forEach(order => this.observed.set(order.orderId, {
      version: kitchenVersion(order), ready: paymentReady(order),
    }));
    this.initialized = true;
  }

  shouldPrint(order: IOrder): boolean {
    if (!this.initialized) return false;
    const version = kitchenVersion(order);
    const ready = paymentReady(order);
    const previous = this.observed.get(order.orderId);
    if (!previous || previous.version !== version || (!previous.ready && ready))
      this.pending.add(version);
    this.observed.set(order.orderId, { version, ready });
    return this.pending.has(version) && ready && !order.lastPrintedDate &&
      [OrderStatus.Placed, OrderStatus.InProgress].includes(order.orderStatus);
  }

  accepted(order: IOrder) {
    this.pending.delete(kitchenVersion(order));
  }
}
